import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodValidator } from '@tanstack/zod-adapter';
import z from 'zod';

import { BreadcrumbItemProps } from '@/features/admin/components/AdminPageHeader';
import { getCoursesDefaultParams } from '@/features/courses-list/actions/getCourses';
import { getCoursesQueryOptions } from '@/features/courses-list/queries/getCourses';
import { ManageCoursesListRoot } from '@/features/manage-courses/components/manage-courses/ManageCoursesListRoot';
import { AppPageContent } from '@/features/shared/components/AppPageContent';
import { AppPageHeader } from '@/features/shared/components/AppPageHeader';
import { UserRoles } from '@/lib/constants/auth.constants.ts';
import { requireRole } from '@/lib/validation';

const coursesSearchParams = z.object({
  search: fallback(z.string(), '').default(''),
  page: fallback(z.number(), 0).default(0),
  perPage: fallback(
    z.number(),
    parseInt(getCoursesDefaultParams.limit)
  ).default(parseInt(getCoursesDefaultParams.limit)),
  sort: fallback(z.string(), getCoursesDefaultParams.sort).default(
    getCoursesDefaultParams.sort
  ),
  orderBy: fallback(z.string(), getCoursesDefaultParams.orderBy).default(
    getCoursesDefaultParams.orderBy
  ),
});

export const Route = createFileRoute('/_app/app/admin-section/manage-courses/')(
  {
    component: RouteComponent,
    beforeLoad: requireRole([UserRoles.ADMINISTRATOR]),
    validateSearch: zodValidator(coursesSearchParams),
    loaderDeps: ({ search }) => ({
      search,
    }),
    loader: async ({ context, deps }) => {
      const { search } = deps;
      await context.queryClient.prefetchQuery(
        getCoursesQueryOptions({
          offset: String(search.page * search.perPage),
          limit: String(search.perPage),
          sort: search.sort,
          orderBy: search.orderBy,
          search: search.search,
        })
      );
    },
    ssr: false,
  }
);

const breadcrumbItems: BreadcrumbItemProps[] = [
  {
    label: 'Home',
    link: { to: '/app' },
  },
  {
    label: 'Administration',
    link: { to: '/app' },
  },
  {
    label: 'Manage Courses',
    link: { to: '/app/admin-section/manage-courses' },
  },
];

function RouteComponent() {
  return (
    <AppPageContent className="overflow-hidden h-[calc(100%-16px)] flex flex-col">
      <AppPageHeader breadcrumbItems={breadcrumbItems} />
      <ManageCoursesListRoot />
    </AppPageContent>
  );
}
